import React from "react";
import {QuickGuide, QuickGuideProps, QuickGuideStates} from "../QuickGuide";
import {RawProvider} from "../../../../res/RawProvider";

export class LoginQuickGuide extends React.Component<QuickGuideProps, QuickGuideStates> {

    render() {
        return <div>
            <QuickGuide
                steps={RawProvider.quickGuide.login}/>;
        </div>
    }

}
